import {HttpParams} from '@angular/common/http';
import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {BaseComponent, SearchQuery, Term} from 'compob2b-libs';
import {Observable, of} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map, switchMap, takeUntil} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';

@Component({
    selector: 'app-search-ranging-relation',
    templateUrl: './search-ranging-relation.component.html',
    standalone: false
})
export class SearchRangingRelationComponent extends BaseComponent implements OnInit {

  @Input() title: any = '';
  @Input() searchPlaceholder: any = '';

  @Input() modelId: any;
  @Input() urlGet: any;
  @Input() urlSearch: any;
  @Input() urlSave: any;
  @Input() urlDelete: any;
  inputFormControl: FormControl;
  terms$: Observable<Term[]>;
  queries: SearchQuery[] = [];

  ngOnInit(): void {
    this.getQuery();
    this.inputFormControl = new FormControl();
    this.terms$ = this.inputFormControl.valueChanges
      .pipe(
        debounceTime(100),
        distinctUntilChanged(),
        filter(term => term !== null),
        map((term: string) => term.length < 2 ? null : term),
        switchMap((term: string) => this.searchTerms(term)),
      );
  }

  getQuery() {
    this.compoApiService.get<SearchQuery[]>(this.urlGet + this.modelId).pipe(takeUntil(this.unsubscribe)).subscribe(
      response => {
        this.queries = response.data;
        this.cdr.detectChanges();
      }
    );
  }

  searchTerms(term: string): Observable<Term[]> {
    const url = this.urlSearch;
    if (null === term) {
      return of([]);
    }
    term = term.toLowerCase();
    const params = new HttpParams().set('header', term);

    return this.compoApiService.getWithParams<Term[]>(url, params).pipe(
      map(response => {
        return response.data;
      })
    );

  }

  insertTerm(term: Term) {
    if (term) {
      this.compoApiService.get<SearchQuery[]>(this.urlSave + this.modelId + '/' + term.id)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          response => {
            this.queries = response.data;
            this.inputFormControl.setValue('');
            this.cdr.detectChanges();
          }
        );
    }
  }

  removeTerm(term: SearchQuery) {
    this.confirm(translations.confirmDelete + ' ' + translations.relationship + '?', new Observable(() => {
      if (term) {
        this.compoApiService.get<SearchQuery[]>(this.urlDelete + this.modelId + '/' + term.id)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            response => {
              this.queries = response.data;
              this.inputFormControl.setValue('');
              this.cdr.detectChanges();
            }
          );
      }
    }));
  }

  viewHandle(value: string) {
    return typeof value === 'string' ? value.toLowerCase() : value;
  }

  changeWeight(manufacturerId, $event) {
    console.log($event.target.value);
    console.log(manufacturerId);
    this.compoApiService
      .post('/search-ranging-group/update-manufactures/' + this.modelId + '/' + manufacturerId,
        {weight: $event.target.value})
      .pipe(takeUntil(this.unsubscribe)).subscribe(
      response => {
        this.successToast(translations.updated);
        this.cdr.detectChanges();
      }
    );
  }
}
